import { render, staticRenderFns } from "./DialogConfirmApprove.vue?vue&type=template&id=bdd86e6e&"
import script from "./DialogConfirmApprove.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports